var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivationScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.984,
    height: 20,
    viewBox: "0 0 19.984 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#ff4e4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1192.459 -5339.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1174.955,5345.246a.752.752,0,0,0-1.038.215l-3.611,5.5-2.453-2.965a.751.751,0,0,0-1.056-.1.744.744,0,0,0-.272.579.741.741,0,0,0,.172.476l3.089,3.736a.827.827,0,0,0,.086.091.733.733,0,0,0,.226.141.757.757,0,0,0,.276.053h.039a.75.75,0,0,0,.32-.09.739.739,0,0,0,.2-.158.791.791,0,0,0,.078-.1l4.16-6.333a.753.753,0,0,0,.123-.412A.747.747,0,0,0-1174.955,5345.246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1188.582,5351.694a.674.674,0,0,0,.014.954.675.675,0,0,0,.941,0h0l3.05-3.05a.673.673,0,0,0,.194-.493.668.668,0,0,0-.194-.493l-3.05-3.048a.676.676,0,0,0-.955.013.674.674,0,0,0,0,.941l1.916,1.913h-5.772a10.423,10.423,0,0,0,0,1.348h5.772Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1192.428,5348.286c.021-.269.047-.536.089-.8C-1192.368,5347.678-1192.4,5347.955-1192.428,5348.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1182.475,5339.055a9.984,9.984,0,0,0-9.8,8.128c-.017.088-.041.173-.055.262l-.006.042c-.042.263-.068.53-.089.8,0,.049-.013.1-.016.145h5.779l-1.916-1.913a.674.674,0,0,1,0-.941.676.676,0,0,1,.955-.013l3.05,3.048a.668.668,0,0,1,.194.493.673.673,0,0,1-.194.493l-3.05,3.05h0a.675.675,0,0,1-.941,0,.674.674,0,0,1-.014-.954l1.917-1.915h-5.774l0,.019c.019.258.053.512.091.764a9.989,9.989,0,0,0,9.87,8.493,10,10,0,0,0,10-10A10,10,0,0,0-1182.475,5339.055Zm3.576,13.563a.791.791,0,0,1-.078.1.739.739,0,0,1-.2.158.75.75,0,0,1-.32.09h-.039a.757.757,0,0,1-.276-.053.733.733,0,0,1-.226-.141.827.827,0,0,1-.086-.091l-3.089-3.736a.741.741,0,0,1-.172-.476.744.744,0,0,1,.272-.579.751.751,0,0,1,1.056.1l2.453,2.965,3.611-5.5a.752.752,0,0,1,1.038-.215.747.747,0,0,1,.339.627.753.753,0,0,1-.123.412Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationScheduled);
export default __webpack_public_path__ + "static/media/activation-scheduled.8eb25bce15a693365adb4948b7f852f6.svg";
export { ForwardRef as ReactComponent };